import { ENGATI_URL } from 'consts/consts';
import { ENGT_CHAT } from 'js/bot.model';

import { poweredBy, setter } from './poweredBy.model';
import { PoweredByTemplate } from './poweredBy.template';

export class PoweredBy {
	constructor(props) {
		setter(props);

		this.init();
		this.html = PoweredByTemplate(poweredBy);
	}

	init() {
		let { url } = poweredBy;
		let { brand } = poweredBy;

		if (ENGT_CHAT.get('config.brand_name') === 'Engati') {
			url = ENGATI_URL;
		} else {
			url = ENGT_CHAT.get('config.poweredByRedirectionURL');
			brand = ENGT_CHAT.get('config.poweredByBrandName');
		}

		setter({
			brand,
			url,
		});
	}

	render() {
		return this.html;
	}
}
